import { Case } from 'services';
export const CaseStreamingMock: Case[] = [
  {
    id: 'CS-001',
    tenant: {
      displayName: 'Mixer',
      tenantId: 'Mixer',
      stackingConfigurationByTitleId: {
        Moderation: {
          enabled: true,
          lookbackWindowInDays: 180,
          maxPoints: 8
        },
        Investigation: {
          enabled: false,
          lookbackWindowInDays: 365,
          maxPoints: 8
        }
      }
    },
    title: {
      displayName: '',
      titleId: 'Moderation'
    },
    subject: {
      subjectId: '517747',
      subjectType: 'Streaming',
      subjectValue:
        '{"output":[{"type":"iframe","value":"https://mixer.com/embed/player/TheWayLife2019?hideChannel=false&disableLinks=true"}]}',
      subjectLabels: ['Livestream'],
      subjectOwners: [
        {
          userId: '734538',
          username: 'Ninja',
          userType: 'Mixer'
        }
      ],
      subjectHashes: undefined,
      subjectMetadata: undefined
    },
    caseEvidence: {
      'Channel URL': 'https://www.mixer.com/Ninja',
      'Channel ID': '12345',
      'Channel Title': '2v2 Tournament Mode!',
      'Channel Partnered': 'True',
      'Channel Featured': 'False',
      'Channel Audience': '18+',
      'Mixer ID': '67890',
      'Mixer Name': 'Ninja',
      Game: 'Call of Duty: Modern Warfare',
      'Current Viewers': '464',
      'Total Viewers': '38780',
      'Total Followers': '8720',
      'Stream Duration': '00:09:20'
    },
    caseCreationDateTime: '2019-07-11T12:30:01Z',
    caseAssignedStartTime: '2019-08-18T21:14:08.144Z',
    caseClosedDateTime: '0001-01-01T00:00:00',
    status: 'Open',
    caseContext: {},
    opinion: {},
    caseActions: [],
    feedbacks: [],
    groundTruthCaseActions: false,
    outOfSla: false
  }
];
